module.exports = __webpack_public_path__ + "img/header.f48aa281.png";